import { Component, Input, OnInit, ViewChildren } from '@angular/core';
import { Chart, registerables } from 'chart.js';
import annotationPlugin from 'chartjs-plugin-annotation';
import pdfMake from 'pdfmake/build/pdfmake';
import domtoimage from 'dom-to-image';
import { MeasureService } from 'src/app/modules/measure/measure.service';
import { map } from 'rxjs/operators';
import { DateTimePipe } from 'src/app/shared/pipe/date.pipe';

@Component({
  selector: 'lifedi-report-standard',
  templateUrl: './report-standard.component.html',
  styleUrls: ['./report-standard.component.scss'],
})
export class ReportStandardComponent implements OnInit {
  @Input() measureid: string;
  @Input() type: string;
  @Input() view_status: number;
  @Input() access_id: string;
  @Input() informant_type: string;
  @ViewChildren('allcanvas') myCharts: any;

  isLoading: boolean = false;
  data_report;
  // data_report = [
  //   {
  //     reportname: 'รายงานแบบทดสอบ',
  //     measure_name: 'แบบทดสอบพัฒนา',
  //     report_description: 'คำอธิบายรายงานแบบทดสอบ',
  //     data: [
  //       {
  //         id: '0',
  //         type_output: 'pandtscore',
  //         psy_name: 'Fairness111',
  //         psy_description: 'คำอธิบายลักษณะทางจิตวิทยา 1',
  //         min: '0', //fix depend on type_output (pandtscore)
  //         max: '100', //fix depend on type_output (pandtscore)
  //         value: '4',
  //         value_chart: '1.2', //% & tscore divided by 20 and plus 1
  //         range: '3-5',
  //         range_description:
  //           'ในคำอธิบาย Lock จำนวน text คำอธิบายอาจจะบังคับ 500 ตัว (ดูตามความเหมาะสมให้ด้วย) 200 ในคำอธิบาย Lock จำนวน text คำอธิบายอาจจะบังคับ 500 ตัว (ดูตามความเหมาะสมให้ด้วย) 200 ในคำอธิบาย Lock จำนวน text คำอธิบาย',
  //         color: '#40559F',
  //       },
  //       {
  //         id: '1',
  //         type_output: 'zscore',
  //         psy_name: 'Fairness222',
  //         psy_description: 'คำอธิบายลักษณะทางจิตวิทยา 2',
  //         min: '-3', //fix depend on type_output (zscore)
  //         max: '3', //fix depend on type_output (zscore)
  //         value: '2.3',
  //         value_chart: '5.3', //zscore plus 3
  //         range: '2-5',
  //         range_description:
  //           'ในคำอธิบาย Lock จำนวน text คำอธิบายอาจจะบังคับ 500 ตัว (ดูตามความเหมาะสมให้ด้วย) 200 ในคำอธิบาย Lock จำนวน text คำอธิบายอาจจะบังคับ 500 ตัว (ดูตามความเหมาะสมให้ด้วย) 200 ในคำอธิบาย Lock จำนวน text คำอธิบาย',
  //         color: '#40559F',
  //       },
  //       {
  //         id: '2',
  //         type_output: 'zscore',
  //         psy_name: 'Fairness222',
  //         psy_description: 'คำอธิบายลักษณะทางจิตวิทยา 2',
  //         min: '-3', //fix depend on type_output (zscore)
  //         max: '3', //fix depend on type_output (zscore)
  //         value: '2.3',
  //         value_chart: '5.3', //zscore plus 3
  //         range: '2-5',
  //         range_description:
  //           'ในคำอธิบาย Lock จำนวน text คำอธิบายอาจจะบังคับ 500 ตัว (ดูตามความเหมาะสมให้ด้วย) 200 ในคำอธิบาย Lock จำนวน text คำอธิบายอาจจะบังคับ 500 ตัว (ดูตามความเหมาะสมให้ด้วย) 200 ในคำอธิบาย Lock จำนวน text คำอธิบาย',
  //         color: '#40559F',
  //       },
  //     ],
  //   },
  // ];

  constructor(private measureService: MeasureService) { }

  ngOnInit(): void {
    Chart.register(...registerables);
    Chart.register(annotationPlugin);

    this.isLoading = true;
    let body;
    if (this.access_id) {
      body = {
        MEASURE_ID: this.measureid,
        TYPE_REPORT: this.type,
        ACCESS_ID: this.access_id,
        INFORMANT_TYPE: this.informant_type,
      };
    } else {
      body = {
        MEASURE_ID: this.measureid,
        TYPE_REPORT: this.type,
        INFORMANT_TYPE: this.informant_type,
      };
    }

    this.measureService
      .getReportByMeasureId(body)
      .pipe(
        map((res) => {
          this.data_report = [res.result];

          setTimeout(() => {
            let zscore = ['', '-2', '-1', '0', '1', '2', ''];
            let pandtscore = ['', '0', '25', '50', '75', '100', ''];
            let curve_data = [0.01, 0.2, 1.35, 4, 1.35, 0.2, 0.01];

            for (let i = 0; i < this.data_report[0].data.length; i++) {
              // console.log(this.data_report[0]);

              var myChart1 = new Chart('StandardChart' + i, {
                type: 'line',
                data: {
                  labels:
                    this.data_report[0].data[i].type_output === 'zscore'
                      ? zscore
                      : pandtscore,
                  datasets: [
                    {
                      data: curve_data,
                      fill: true,
                      pointRadius: 0,
                      backgroundColor: 'rgba(195, 195, 195, 0.5)',
                      borderColor: 'rgba(0, 0, 0, 0.25)',
                      borderWidth: 1,
                    },
                  ],
                },
                options: {
                  elements: {
                    line: {
                      tension: 0.5,
                    },
                  },
                  scales: {
                    y: {
                      beginAtZero: true,
                      max: 4.5,
                      ticks: {
                        display: false,
                      },
                    },
                  },
                  plugins: {
                    tooltip: {
                      enabled: false,
                    },
                    legend: {
                      display: false,
                    },
                    annotation: {
                      annotations: [
                        {
                          type: 'line',
                          xMin: +this.data_report[0].data[i].value_chart,
                          xMax: +this.data_report[0].data[i].value_chart,
                          borderColor: this.data_report[0].data[i].color,
                          borderWidth: 2,
                          label: {
                            enabled: true,
                            color: 'white',
                            content: parseFloat(this.data_report[0].data[i].value).toFixed(2),
                            backgroundColor: this.data_report[0].data[i].color,
                          },
                        },
                      ],
                    },
                  },
                },
              });
            }
            for (let i = 0; i < this.data_report[0].data.length; i++) {
              var myChart2 = new Chart('StandardChartpdf' + i, {
                type: 'line',
                data: {
                  labels:
                    this.data_report[0].data[i].type_output === 'zscore'
                      ? zscore
                      : pandtscore,
                  datasets: [
                    {
                      data: curve_data,
                      fill: true,
                      pointRadius: 0,
                      backgroundColor: 'rgba(195, 195, 195, 0.5)',
                      borderColor: 'rgba(0, 0, 0, 0.25)',
                      borderWidth: 1,
                    },
                  ],
                },
                options: {
                  elements: {
                    line: {
                      tension: 0.5,
                    },
                  },
                  scales: {
                    y: {
                      beginAtZero: true,
                      max: 4.5,
                      ticks: {
                        display: false,
                      },
                    },
                  },
                  plugins: {
                    tooltip: {
                      enabled: false,
                    },
                    legend: {
                      display: false,
                    },
                    annotation: {
                      annotations: [
                        {
                          type: 'line',
                          xMin: +this.data_report[0].data[i].value_chart,
                          xMax: +this.data_report[0].data[i].value_chart,
                          borderColor: this.data_report[0].data[i].color,
                          borderWidth: 2,
                          label: {
                            enabled: true,
                            color: 'white',
                            content: parseFloat(this.data_report[0].data[i].value).toFixed(2),
                            backgroundColor: this.data_report[0].data[i].color,
                          },
                        },
                      ],
                    },
                  },
                },
              });
            }
          }, 100);
          setTimeout(() => {
            this.filepdf();
            this.isLoading = true;
          }, 1000);
        })
        // map(() => {
        //   this.filepdf();
        //   this.isLoading = true;
        // })
      )
      .subscribe();
  }

  downloadpdf() {
    let formattedDate = new DateTimePipe().transform(
      this.data_report[0].done_measure_date.toString(),
      'FullNoTime'
    );
    let userid = this.data_report[0].user_id;
    let username = this.data_report[0].username;
    // console.log(typeof formattedDate);
    let alldata = this.data_report;
    let NewArray = [];
    for (let i = 0; i < alldata[0].data.length; i++) {
      let a = document.getElementById('StandardChartpdf' + i);
      NewArray.push(a);
    }
    // console.log(NewArray);
    // console.log(formattedDate);

    Promise.all(NewArray.map((node) => domtoimage.toPng(node))).then(
      (dataArray) => {
        dataArray[0];
        var img = new Image();
        img.src = dataArray[0];
        pdfMake.fonts = {
          THsarabunNew: {
            normal: 'THSarabun.ttf',
            bold: 'THSarabunNew Bold.ttf',
            italics: 'THSarabunNew Italic.ttf',
            bolditalics: 'THSarabunNew BoldItalic.ttf',
          },
        };
        const allPage = {
          pageSize: 'A4',
          pageOrientation: 'portrait',
          header: function (currentPage) {
            return [
              {
                text: username + ' ( userid : ' + userid + ' )' + '  | ' + formattedDate + ' หน้า ' + currentPage.toString(),
                width: '*',
                alignment: 'right',
                margin: [40, 20],
              },
            ];
          },
          content: [
            {
              text: this.data_report[0].reportname,
              alignment: 'center',
              fontSize: 24,
              color: '#060e9f',
              margin: [0, 10],
              bold: true,
            },
            {
              text: this.data_report[0].measure_name,
              alignment: 'left',
              fontSize: 22,
              decoration: 'underline',
              margin: [0, 10],
              bold: true,
            },
            {
              text: this.data_report[0].report_description,
              width: '*',
              fontSize: 16,
              margin: [0, 0, 0, 15],
            },
            {
              image: dataArray[0],
              width: 300,
              alignment: 'center',
              margin: [0, 40],
              pageBreak: '',
            },
            {
              text: this.data_report[0].data[0].psy_name,
              alignment: 'left',
              decoration: 'underline',
              color: '#060e9f',
              margin: [0, 0, 0, 5],
              width: 'auto',
              fontSize: 18,
              bold: true,
            },
            {
              text: this.data_report[0].data[0].psy_description,
              width: '*',
              fontSize: 14,
              margin: [0, 0, 0, 10],
            },
            {
              text:
                'คะแนนต่ำสุด : ' +
                this.data_report[0].data[0].min +
                ' คะแนนสูงสุด : ' +
                this.data_report[0].data[0].max,
              alignment: 'left',
              fontSize: 18,
              color: '#000000',
              margin: [0, 10, 0, 0],
              bold: true,
            },
            {
              text:
                'ท่านได้ ' +
                parseFloat(this.data_report[0].data[0].value).toFixed(2) +
                ' คะแนน',
              // ' อยู่ในช่วงคะแนน ' +
              // this.data_report[0].data[0].range +
              // ' คะแนน',
              alignment: 'left',
              fontSize: 18,
              color: '#060e9f',
              margin: [0, 5, 0, 0],
              bold: true,
            },
            {
              text: this.data_report[0].data[0].range_description,
              width: '*',
              fontSize: 14,
              margin: [0, 0, 0, 10],
            },
          ],
          defaultStyle: {
            font: 'THsarabunNew',
          },
        };
        for (let i = 1; i < alldata[0].data.length; i++) {
          dataArray[i];
          let img2 = new Image();
          img2.src = dataArray[i];
          allPage.content.push(
            {
              image: dataArray[i],
              width: 300,
              alignment: 'center',
              margin: [0, 20],
              pageBreak: 'before',
            },
            {
              text: this.data_report[0].data[i].psy_name,
              alignment: 'left',
              decoration: 'underline',
              color: '#060e9f',
              margin: [0, 0, 0, 5],
              width: 'auto',
              fontSize: 18,
              bold: true,
            },
            {
              text: this.data_report[0].data[i].psy_description,
              width: '*',
              fontSize: 14,
              margin: [0, 0, 0, 10],
            },
            {
              text:
                'คะแนนต่ำสุด : ' +
                this.data_report[0].data[i].min +
                ' คะแนนสูงสุด : ' +
                this.data_report[0].data[i].max,
              alignment: 'left',
              fontSize: 18,
              color: '#000000',
              margin: [0, 10, 0, 0],
              bold: true,
            },
            {
              text:
                'ท่านได้ ' +
                parseFloat(this.data_report[0].data[i].value).toFixed(2) +
                ' คะแนน',
              // ' อยู่ในช่วงคะแนน ' +
              // this.data_report[0].data[i].range +
              // ' คะแนน',
              alignment: 'left',
              fontSize: 18,
              color: '#060e9f',
              margin: [0, 5, 0, 0],
              bold: true,
            },
            {
              text: this.data_report[0].data[i].range_description,
              width: '*',
              fontSize: 14,
              margin: [0, 0, 0, 10],
            }
          );
        }
        pdfMake.createPdf(allPage).open();
      }
    );
  }
  filepdf() {
    let formattedDate = new DateTimePipe().transform(
      this.data_report[0].done_measure_date.toString(),
      'FullNoTime'
    );
    let userid = this.data_report[0].user_id;
    let alldata = this.data_report;
    let NewArray = [];
    for (let i = 0; i < alldata[0].data.length; i++) {
      let a = document.getElementById('StandardChartpdf' + i);
      NewArray.push(a);
      // console.log(i);
    }
    // console.log(NewArray);

    Promise.all(NewArray.map((node) => domtoimage.toPng(node))).then(
      (dataArray) => {
        dataArray[0];
        var img = new Image();
        img.src = dataArray[0];
        pdfMake.fonts = {
          THsarabunNew: {
            normal: 'THSarabun.ttf',
            bold: 'THSarabunNew Bold.ttf',
            italics: 'THSarabunNew Italic.ttf',
            bolditalics: 'THSarabunNew BoldItalic.ttf',
          },
        };
        const allPage = {
          pageSize: 'A4',
          pageOrientation: 'portrait',
          header: function (currentPage) {
            return [
              {
                text: userid + ' | ' + formattedDate + ' หน้า ' + currentPage.toString(),
                width: '*',
                alignment: 'right',
                margin: [40, 20],
              },
            ];
          },
          content: [
            {
              text: this.data_report[0].reportname,
              alignment: 'center',
              fontSize: 24,
              color: '#060e9f',
              margin: [0, 10],
              bold: true,
            },
            {
              text: this.data_report[0].measure_name,
              alignment: 'left',
              fontSize: 22,
              decoration: 'underline',
              margin: [0, 10],
              bold: true,
            },
            {
              text: this.data_report[0].report_description,
              width: '*',
              fontSize: 16,
              margin: [0, 0, 0, 15],
            },
            {
              image: dataArray[0],
              width: 300,
              alignment: 'center',
              margin: [0, 40],
              pageBreak: '',
            },
            {
              text: this.data_report[0].data[0].psy_name,
              alignment: 'left',
              decoration: 'underline',
              color: '#060e9f',
              margin: [0, 0, 0, 5],
              width: 'auto',
              fontSize: 18,
              bold: true,
            },
            {
              text: this.data_report[0].data[0].psy_description,
              width: '*',
              fontSize: 14,
              margin: [0, 0, 0, 10],
            },
            {
              text:
                'คะแนนต่ำสุด : ' +
                this.data_report[0].data[0].min +
                ' คะแนนสูงสุด : ' +
                this.data_report[0].data[0].max,
              alignment: 'left',
              fontSize: 18,
              color: '#000000',
              margin: [0, 10, 0, 0],
              bold: true,
            },
            {
              text:
                'ท่านได้ ' +
                parseFloat(this.data_report[0].data[0].value).toFixed(2) +
                ' คะแนน',
              // ' อยู่ในช่วงคะแนน ' +
              // this.data_report[0].data[0].range +
              // ' คะแนน',
              alignment: 'left',
              fontSize: 18,
              color: '#060e9f',
              margin: [0, 5, 0, 0],
              bold: true,
            },
            {
              text: this.data_report[0].data[0].range_description,
              width: '*',
              fontSize: 14,
              margin: [0, 0, 0, 10],
            },
          ],
          defaultStyle: {
            font: 'THsarabunNew',
          },
        };
        for (let i = 1; i < alldata[0].data.length; i++) {
          dataArray[i];
          let img2 = new Image();
          img2.src = dataArray[i];
          allPage.content.push(
            {
              image: dataArray[i],
              width: 300,
              alignment: 'center',
              margin: [0, 20],
              pageBreak: 'before',
            },
            {
              text: this.data_report[0].data[i].psy_name,
              alignment: 'left',
              decoration: 'underline',
              color: '#060e9f',
              margin: [0, 0, 0, 5],
              width: 'auto',
              fontSize: 18,
              bold: true,
            },
            {
              text: this.data_report[0].data[i].psy_description,
              width: '*',
              fontSize: 14,
              margin: [0, 0, 0, 10],
            },
            {
              text:
                'คะแนนต่ำสุด : ' +
                this.data_report[0].data[i].min +
                ' คะแนนสูงสุด : ' +
                this.data_report[0].data[i].max,
              alignment: 'left',
              fontSize: 18,
              color: '#000000',
              margin: [0, 10, 0, 0],
              bold: true,
            },
            {
              text:
                'ท่านได้ ' +
                parseFloat(this.data_report[0].data[i].value).toFixed(2) +
                ' คะแนน',
                // ' อยู่ในช่วงคะแนน ' +
                // this.data_report[0].data[i].range +
                // ' คะแนน',
              alignment: 'left',
              fontSize: 18,
              color: '#060e9f',
              margin: [0, 5, 0, 0],
              bold: true,
            },
            {
              text: this.data_report[0].data[i].range_description,
              width: '*',
              fontSize: 14,
              margin: [0, 0, 0, 10],
            }
          );
        }
        var pdfDocGenerator = pdfMake.createPdf(allPage);
        pdfDocGenerator.getBase64((base64str) => {
          // console.log(base64str);
          let data = {
            MEASURE_ID: this.measureid,
            TYPE: this.type,
            base64str: base64str,
            view: this.view_status
          };
          this.measureService.SaveReportMeasureId(data).subscribe((res) => {
            // // console.log(res);
          });
        });
      }
    );
  }
}
